<template>
  <div>
    <!-- no-close-on-backdrop
      no-close-on-esc -->
    <b-modal
      ref="modal-location-codes"
      :title="$t('UPDATE CODES')"
      modal-class="modal-primary"
      @hidden="$emit('hideModal')"
      size="md"
      no-close-on-backdrop
    >
      <ValidationObserver ref="form-validation">
        <b-row>
          <!-- DEPARTMENT -->
          <b-col cols="6">
            <b-form-group :label="$t('Department')">
              <v-select
              v-model="deptSelected"
              :options="departments"
              :reduce="(val) => val.id"
              label="name"
              @input="changeDept"
              ></v-select>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <ValidationProvider
            v-slot="{ errors }"
            rules="required|max:4"
            name="code"
            >
              <b-form-group 
              :label="$t('Code')"
              :state="errors[0] ? false : null"
              >
                <b-form-input
                type="text"
                v-model="form.code"
                :disabled="deptSelected == null"
                :class="{ 'border-danger': errors[0] }"
                @change="verifyDuplicated('departments')"
                ></b-form-input>
                <span v-if="errors[0]" class="text-danger">
                  Code {{ errors[0] }}
                </span>                
              </b-form-group>
            </ValidationProvider>
          </b-col>

          <!-- SELECTEDS -->
          <b-col cols="12">
            <b-form-group
              :label="$t('Provinces')"
              class="mt-1"
            />
            <div class="overflow-auto" style="height: 300px">
              <div
                v-for="prov in provinces"
                :key="prov.id"         
              >
                <b-row>
                  <b-col cols="6">
                    <span>{{prov.name}}</span>
                  </b-col>
                  <b-col cols="6">
                    <ValidationProvider
                    v-slot="{ errors }"
                    rules="max:4"
                    name="code"
                    >
                      <b-form-group>
                        <b-form-input
                        type="text"
                        v-model="prov.code"
                        :class="{ 'border-danger': errors[0] }"
                        @change="verifyDuplicated('provinces', prov)"
                        ></b-form-input>
                        <span v-if="errors[0]" class="text-danger">
                          Code {{ errors[0] }}
                        </span>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-col>          
        </b-row>
      </ValidationObserver>
      <template #modal-footer>
        <b-container fluid>
          <b-row>
            <b-col class="d-flex align-items-center justify-content-end p-0">
              <b-button
                class="mr-1"
                @click="$emit('hideModal', false)"
                v-t="'CANCEL'"
              >
              </b-button>
              <b-button variant="primary" @click="save" :disabled="deptSelected == null">
                {{ $t('SAVE') }}
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </b-modal>
  </div>
</template>

<script>
/* Service */
import TravelRoutesService from "@/views/settings/views/travel-routes/services/travel-routes.service.js";
import { mapGetters } from "vuex"
export default {
  components: {},
  data() {
    return {
      items: [],
      form: {
        code: null
      },
      departments: [],
      provinces: [],
      provincesCpy: [],
      deptSelected: null,
      codeCpy: null,
    };
  },
  mounted() {
    this.toggleModal("modal-location-codes");
  },
  async created() {    
    this.addPreloader();
    try {
      if(this.zoneId != null){
        await this.getZoneData();
      }
      await this.getDepartments();
    } catch (error) {
      this.showToastError("Proceso fallido", "Error")
    } finally {
      this.removePreloader(); 
    }
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser"
    })
  },
  methods: {
    async changeDept(val){
      this.deptSelected = this.departments.filter(dept => dept.id == val);
      this.form.code = this.deptSelected[0].code
      await this.getProvinces(val)
    },
    resetList(){
      this.districts = this.districtsBckp.filter(dist => {
        return !this.form.distSelectedList.some(dist2 => dist2.id === dist.id);
      });
      this.distSelected = null;
    },
    async save(){
      const validate = await this.$refs["form-validation"].validate();
      if(validate){
        const confirm = await this.showConfirmSwal();
        if(!confirm.isConfirmed) return;
        const params = {
          "department_id": this.deptSelected[0].id,
          "code": this.form.code,
          "user_id": this.currentUser.employee_id,
          "provinces": this.provinces
        }
        try {
          this.addPreloader();
          const { data } = await TravelRoutesService.updateCodes(params);
          if(data.success){
            this.showToastSuccess("Proceso exitoso", "Exito")
            this.$emit("refreshTable");
            this.$emit("hideModal");
          }else{
            this.showToastError("Proceso fallido", "Error")
          }
        } catch (error) {
          this.showToastError();
        } finally {
          this.removePreloader();
        }
      }
    },
    async getDepartments(){
      const { data } = await TravelRoutesService.getDepartments();
      this.departments = data;
    },
    async getProvinces(id){
      const { data } = await TravelRoutesService.getProvinces(id);
      this.provinces = data;
      this.provincesCpy = JSON.parse(JSON.stringify(data))
    },
    async verifyDuplicated(model, item){
      let value;
      if(model == "provinces"){
        value = item.code
        let prov = this.provincesCpy.filter(prov => prov.id == item.id)
        this.codeCpy = prov[0].code;
      }else{
        value = this.form.code;
      }
      const params = {
        table: model,
        value: value
      }
      const { data } = await TravelRoutesService.verifyDuplicatedCode(params);
      if(data.is_duplicated){
        this.showToastWarning("El dato ingresado fue registrado anteriormente", "Oops...")
        if(model == 'departments'){
          this.form.code = null;
        }else{
          let index = this.provinces.findIndex(prov => prov.id == item.id)
          this.provinces[index].code = this.codeCpy
          this.codeCpy = null;
        }
      }
    },
    hideModal(){
      this.$emit("hideModal");
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-autosuggest.scss";
</style>